export const getCustomStyles = (darkTheme: boolean, isMonth: boolean) => ({
  control: (base: any) => ({
    ...base,
    backgroundColor: "transparent",
    border: "none",
    color: darkTheme ? "#FFFFFF" : "#000000",
    outline: "none",
    boxShadow: "none",
  }),
  input: (base: any) => ({
    ...base,
    color: darkTheme ? "#e2e8f0" : "#2d3748",
    outline: "none",
  }),
  menu: (base: any) => ({
    ...base,
    backgroundColor: darkTheme ? "#404040" : "#f5f5f5",
    color: darkTheme ? "#e2e8f0" : "#2d3748",
    marginTop: "-5px",
    minWidth: isMonth ? "90px" : "60px",
  }),
  option: (base: any, { isFocused }: any) => ({
    ...base,
    backgroundColor: isFocused
      ? darkTheme
        ? "#86BC25"
        : "#86BC25"
      : darkTheme
        ? "#404040"
        : "#f5f5f5",
    color: darkTheme ? "#FFFFFF" : "#000000",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: darkTheme ? "#FFFFFF" : "#000000",
    fontWeight: "bold",
    fontSize: 15,
    display: "flex",
    alignItems: "right",
  }),
  indicatorSeparator: (base: any) => ({
    display: "none",
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    paddingLeft: "0px !important",
    color: darkTheme ? "#FFFFFF" : "#000000",
    ":hover": {
      color: darkTheme ? "#a3a3a3" : "#525252",
    },
  }),
});
